import axios from "axios";

export const createInvoiceRecordAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/invoiceRecord`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response;
};

export const getNonInvoicedBookingAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/invoiceRecord/getNonInvoicedBookings`,
    {
      headers: {
        Authorization: `${payload.token}`,
      },
    }
  );
  return response;
};

export const checkTokenExistAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/invoiceRecord/checkInvoiceNumberExists?invoiceNumber=${payload.invoiceNumber}`,
    {
      headers: {
        Authorization: `${payload.token}`,
      },
    }
  );
  return response;
};

export const getAllInvoiceRecordAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/invoiceRecord`,
    {
      headers: {
        Authorization: `${payload.token}`,
      },
    }
  );
  return response;
};

export const getInvoiceRecordByIdAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/invoiceRecord/eachInvoiceRecord?invoiceNumber=${payload.invoiceNumber}`,
    {
      headers: {
        Authorization: `${payload.token}`,
      },
    }
  );
  return response;
};

export const updateInvoiceRecordAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/invoiceRecord/eachInvoiceRecord?invoiceNumber=${payload.invoiceNumber}`,
    payload.body,
    {
      headers: {
        Authorization: `${payload.token}`,
      },
    }
  );
  return response;
};

export const deleteInvoiceRecordAction = async (payload) => {
  const response = await axios.delete(
    `${process.env.REACT_APP_BASE_URL}/invoiceRecord/eachInvoiceRecord?invoiceNumber=${payload.invoiceNumber}`,
    {
      headers: {
        Authorization: `${payload.token}`,
      },
    }
  );
  return response;
};
